/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { MutableRefObject } from 'react';
import { PhotoSwipeOptions } from 'photoswipe';
import 'photoswipe/dist/photoswipe.css';

import { Gallery, Item } from 'react-photoswipe-gallery';
import { Credit, Subtitle } from '../image/styles';
import { WrapGallery } from './styles';
import { IImage } from '../image';
import getObjectByKey from '../../utils/get-Image-By-Key';
import normalizeText from '../../utils/normalize-Text';

export interface IGallery {
    images: IImage[] | IImage;
}

const options = {
    initialZoomLevel: 'fit',
    secondaryZoomLevel: 2,
    maxZoomLevel: 5,
    padding: { top: 20, bottom: 40, left: 100, right: 100 },
} as PhotoSwipeOptions;

function CustomGallery({ images }: IGallery) {
    const imageArray = Array.isArray(images) ? images : [images as IImage];

    return (
      <WrapGallery>
        <Gallery options={options}>
          {imageArray.map((item) => {
            const src: string = item.src ? item.src : getObjectByKey(item.retranca);
            const size: string = normalizeText(item.tamanho ?? '') || 'grande';
            return (
              <Item
                original={src}
                thumbnail=""
                width="1024"
                height="768"
              >
                {({ ref, open }) => (
                  <div className={size}>
                    <img
                      ref={ref as React.MutableRefObject<HTMLImageElement>}
                      onClick={open}
                      src={src}
                      alt={item.texto_alternativo}
                    />
                    {item.legenda && <Subtitle>{item.legenda}</Subtitle>}
                    {item.fonte && <Subtitle>{item.fonte}</Subtitle>}
                    {item.credito && <Credit className="credit">{item.credito}</Credit>}
                  </div>
                )}
              </Item>
            );
})}
        </Gallery>
      </WrapGallery>
    );
}

export default CustomGallery;
